import type * as React from 'react'
import { cn } from '@/lib/cn'

/**
 * The state a panel shows when it has nothing to show. Generous vertical space
 * on purpose — an empty region that looks cramped reads as a broken region.
 */
export function EmptyState(p: {
  icon?: React.ReactNode
  title: string
  description?: string
  action?: React.ReactNode
}) {
  return (
    <div
      className={cn(
        'flex min-h-[240px] flex-col items-center justify-center gap-4 px-6 py-12 text-center'
      )}
    >
      {p.icon ? (
        <span
          aria-hidden="true"
          className="flex size-11 items-center justify-center rounded-lg border border-line bg-s2 text-faint [&_svg]:size-5"
        >
          {p.icon}
        </span>
      ) : null}

      <div className="space-y-1.5">
        <p className="font-display text-[15px] leading-5 font-semibold text-fg">{p.title}</p>
        {p.description ? (
          <p className="mx-auto max-w-[44ch] text-[13px] leading-[1.6] text-muted">
            {p.description}
          </p>
        ) : null}
      </div>

      {p.action ? <div className="pt-0.5">{p.action}</div> : null}
    </div>
  )
}
